import i18next from "i18next";

export const formatNumber = (value: number, maxDecimalPlaces = 2) => {
  return new Intl.NumberFormat(i18next.language, {
    style: "decimal",
    maximumFractionDigits: maxDecimalPlaces,
  }).format(value);
};

export const formatPercentage = (value: number, maxDecimalPlaces = 2) => {
  return `${formatNumber(value, maxDecimalPlaces)}%`;
};

export const calculatePercentage = (part: number, total: number): number => {
  if (total === 0) {
    return 0;
  }
  return (part / total) * 100;
};
